import React from "react";
import profilePicture from "../../Image/Main_logo.png"; // Adjust path as needed
import Cookies from "js-cookie";

const userProfile = {
  name: "John Doe",
  email: "john.doe@example.com",
  bio: "Passionate web developer and tech enthusiast. Always learning and building.",
  profilePicture: profilePicture,
  location: "Vadodara, Gujarat, India",
  joinedDate: "January 2023",
  socialLinks: {
    github: "https://github.com/johndoe",
    linkedin: "https://linkedin.com/in/johndoe",
    twitter: "https://twitter.com/johndoe",
  },
};

const ViewProfile = () => {
  const loginData = Cookies.get("loginData");
  const LoginUserData = loginData ? JSON.parse(loginData) : null;

  return (
    <>
      <div className="min-h-screen bg-gray-100 py-8 px-2 lg:px-8">
        <div className="max-w-4xl mx-auto dark:bg-gray-800 rounded-lg shadow-xl overflow-hidden md:flex">
          {/* Profile Left Section */}
          <div className="md:w-1/3 p-6 flex flex-col items-center justify-center bg-blue-600 text-white">
            <div className="relative w-32 h-32 md:w-48 md:h-48 rounded-full overflow-hidden border-4 border-white shadow-lg mb-4">
              <img
                src={LoginUserData?.data?.ProfilePhoto}
                alt={`${userProfile.name}'s Profile`}
                className="w-full h-full object-cover rounded-full"
              />
            </div>
            <h1 className="text-3xl font-bold text-center mb-1">
              {LoginUserData?.data?.Name}
            </h1>
            <p className="text-lg text-blue-100 text-center">
              {LoginUserData?.data?.Email}
            </p>
            <button
              onClick={() => alert("Redirect to Edit Page")}
              className="mt-6 px-6 py-2 bg-white text-blue-600 rounded-lg shadow-md hover:bg-gray-100 transition duration-300 ease-in-out font-semibold"
            >
              Edit Profile
            </button>
          </div>

          {/* Profile Right Section */}
          <div className="md:w-2/3 p-8">
            <h2 className="text-2xl font-semibold dark:text-gray-300 mb-6 border-b pb-2 border-gray-200">
              About Me
            </h2>
            <p className="dark:text-gray-300 leading-relaxed mb-6">
              {userProfile.bio}
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <h3 className="text-lg font-semibold dark:text-gray-300 mb-2">
                  Location
                </h3>
                <p className="dark:text-gray-300">{userProfile.location}</p>
              </div>
              <div>
                <h3 className="text-lg font-semibold dark:text-gray-300 mb-2">
                  Member Since
                </h3>
                <p className="dark:text-gray-300">{userProfile.joinedDate}</p>
              </div>
            </div>

            <h2 className="text-2xl font-semibold dark:text-gray-300 mb-6 border-b pb-2 border-gray-200">
              Social Links
            </h2>
            <div className="flex flex-wrap gap-4">
              {userProfile.socialLinks.github && (
                <a
                  href={userProfile.socialLinks.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 text-blue-600 hover:text-blue-800 transition"
                >
                  <svg
                    className="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.499.09.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.909-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.529 2.341 1.088 2.91.829.091-.645.359-1.088.65-1.338-2.22-.253-4.555-1.113-4.555-4.953 0-1.096.391-1.996 1.029-2.715-.103-.253-.446-1.293.098-2.684 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.391.202 2.431.099 2.684.64.719 1.028 1.619 1.028 2.715 0 3.84-2.339 4.69-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.523 2 12 2Z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>GitHub</span>
                </a>
              )}
              {userProfile.socialLinks.linkedin && (
                <a
                  href={userProfile.socialLinks.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 text-blue-600 hover:text-blue-800 transition"
                >
                  <svg
                    className="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fillRule="evenodd"
                      d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>LinkedIn</span>
                </a>
              )}
              {userProfile.socialLinks.twitter && (
                <a
                  href={userProfile.socialLinks.twitter}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 text-blue-600 hover:text-blue-800 transition"
                >
                  <svg
                    className="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M8.29 20.251c-.03.011-.06.022-.091.031A8.966 8.966 0 0012 22c4.972 0 9-4.028 9-9s-4.028-9-9-9-9 4.028-9 9c0 1.979.626 3.805 1.684 5.304-.047-.02-.095-.04-.143-.062-.05-.02-.1-.04-.15-.062l-.001-.001.001.001zM14 8h-4v4H7V8H3V6h4V2h2v4h4v2z" />
                  </svg>
                  <span>Twitter</span>
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewProfile;
